import { api } from '@/features/auth';
import type { SupportFeedbackType } from '../support-feedback-modal';

export interface SupportFeedbackRaw {
    id: string;
    user_created: string;
    date_created: string;
    message: string;
    type: SupportFeedbackType;
    status: 'pending' | 'reviewed' | 'resolved';
}

export interface SupportFeedback {
    id: string;
    userId: string;
    dateCreated: string;
    message: string;
    type: SupportFeedbackType;
    status: 'pending' | 'reviewed' | 'resolved';
}

export interface CreateSupportFeedbackPayload {
    message: string;
    type: SupportFeedbackType;
}

function transformSupportFeedback(raw: SupportFeedbackRaw): SupportFeedback {
    return {
        id: raw.id,
        userId: raw.user_created,
        dateCreated: raw.date_created,
        message: raw.message,
        type: raw.type,
        status: raw.status,
    };
}

export const supportFeedbackApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createSupportFeedback: builder.mutation<SupportFeedback | null, CreateSupportFeedbackPayload>({
            query: ({ message, type }) => ({
                url: '/items/support_feedback',
                method: 'POST',
                body: {
                    message,
                    type,
                    status: 'pending',
                },
            }),
            transformResponse: (response: any) => {
                if (!response || response === null || response === undefined) {
                    return null;
                }

                if (typeof response === 'object' && Object.keys(response).length === 0) {
                    return null;
                }

                if (response.data) {
                    return transformSupportFeedback(response.data);
                }

                if (response.id && response.type && response.message) {
                    return transformSupportFeedback(response as SupportFeedbackRaw);
                }

                console.warn('Unexpected response format:', response);
                return null;
            },
            invalidatesTags: ['SupportFeedback'],
        }),
    }),
});

export const {
    useCreateSupportFeedbackMutation
} = supportFeedbackApi;
